import { transactionTypes, type TransactionType } from "./utils";

/**
 *
 */
export type SamplingEnvConfig = {
  "page-load": { [pagecluster: string]: number[] | undefined };
  "http-request": { [pagecluster: string]: number | undefined };
};

/*                                  */
/**
 *
 *
 */
const pageLoadLive = {
"AftersalesOrders":[	0.903,	1.000,	0.666,	0.307,	0.173,	0.138,	0.145,	0.122,	0.105,	0.091,	0.074,	0.069,	0.078,	0.077,	0.073,	0.076,	0.090,	0.090,	0.105,	0.114,	0.135,	0.177,	0.305,	0.601	],
"Artikeldetailseite":[	0.044,	0.055,	0.044,	0.029,	0.018,	0.015,	0.017,	0.015,	0.013,	0.011,	0.009,	0.008,	0.009,	0.008,	0.007,	0.007,	0.007,	0.007,	0.006,	0.006,	0.006,	0.008,	0.014,	0.025	],
"BBS":[	1.000,	1.000,	1.000,	1.000,	1.000,	0.989,	1.000,	0.953,	0.786,	0.659,	0.533,	0.484,	0.554,	0.511,	0.462,	0.441,	0.462,	0.418,	0.426,	0.435,	0.494,	0.616,	1.000,	1	],
"Checkout":[	1.000,	1.000,	1.000,	1.000,	0.619,	0.478,	0.518,	0.434,	0.349,	0.289,	0.232,	0.217,	0.248,	0.231,	0.209,	0.202,	0.205,	0.190,	0.191,	0.189,	0.211,	0.247,	0.462,	0.889	],
"ConnectContact":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.867,	0.721,	0.623,	0.458,	0.426,	0.493,	0.492,	0.461,	0.506,	0.590,	0.677,	0.789,	0.904,	1.000,	1.000,	1.000,	1	],
"Einstiegsseite":[	0.583,	0.552,	0.474,	0.434,	0.367,	0.377,	0.555,	0.536,	0.424,	0.374,	0.315,	0.286,	0.333,	0.290,	0.306,	0.230,	0.242,	0.255,	0.255,	0.257,	0.277,	0.256,	0.519,	0.563	],
"Kundenbewertungsseite":[	1.000,	1.000,	1.000,	1.000,	0.848,	0.656,	0.778,	0.692,	0.581,	0.489,	0.404,	0.362,	0.389,	0.372,	0.347,	0.325,	0.328,	0.288,	0.282,	0.280,	0.292,	0.353,	0.647,	1	],
"Login":[	1.000,	1.000,	1.000,	0.570,	0.289,	0.213,	0.228,	0.195,	0.164,	0.138,	0.116,	0.106,	0.123,	0.119,	0.110,	0.114,	0.130,	0.125,	0.133,	0.143,	0.171,	0.228,	0.419,	0.799	],
"MYA_Dashboard":[	0.722,	0.799,	0.492,	0.230,	0.150,	0.127,	0.152,	0.136,	0.120,	0.101,	0.081,	0.077,	0.088,	0.085,	0.081,	0.082,	0.086,	0.091,	0.102,	0.107,	0.124,	0.156,	0.256,	0.488	],
"MYA_Invoices":[	1.000,	1.000,	0.635,	0.286,	0.181,	0.159,	0.189,	0.175,	0.153,	0.135,	0.115,	0.110,	0.124,	0.120,	0.114,	0.116,	0.126,	0.130,	0.146,	0.155,	0.184,	0.233,	0.393,	0.71	],
"MYA_Orders":[	0.807,	0.889,	0.518,	0.235,	0.138,	0.110,	0.113,	0.095,	0.083,	0.072,	0.059,	0.055,	0.064,	0.063,	0.060,	0.062,	0.073,	0.075,	0.086,	0.095,	0.114,	0.152,	0.267,	0.524	],
"MYA_UP":[	1.000,	1.000,	1.000,	0.929,	0.612,	0.582,	0.772,	0.844,	0.809,	0.737,	0.626,	0.602,	0.661,	0.655,	0.629,	0.547,	0.551,	0.589,	0.659,	0.685,	0.771,	0.996,	1.000,	1	],
"OM_Returns":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.865,	0.725,	0.771,	0.665,	0.590,	0.621,	0.783,	0.749,	0.911,	1.000,	1.000,	1.000,	1.000,	1	],
"Payment-Selection-FD-ViewPaymentSelection":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.943,	0.762,	0.716,	0.837,	0.765,	0.709,	0.668,	0.683,	0.642,	0.645,	0.594,	0.686,	0.711,	1.000,	1	],
"Paymentinfo":[	1.000,	1.000,	1.000,	0.457,	0.281,	0.229,	0.267,	0.238,	0.209,	0.183,	0.155,	0.147,	0.158,	0.157,	0.148,	0.152,	0.171,	0.171,	0.195,	0.207,	0.249,	0.317,	0.545,	1	],
"Produktliste":[	0.269,	0.296,	0.292,	0.184,	0.123,	0.108,	0.128,	0.117,	0.100,	0.079,	0.064,	0.057,	0.064,	0.059,	0.054,	0.044,	0.036,	0.040,	0.043,	0.041,	0.046,	0.058,	0.103,	0.174	],
"Storefront":[	0.182,	0.201,	0.165,	0.091,	0.069,	0.060,	0.067,	0.063,	0.056,	0.047,	0.039,	0.036,	0.041,	0.038,	0.036,	0.035,	0.034,	0.034,	0.035,	0.035,	0.039,	0.049,	0.077,	0.138	],
"Suchergebnisseite":[	0.114,	0.148,	0.150,	0.093,	0.057,	0.048,	0.054,	0.045,	0.038,	0.030,	0.024,	0.021,	0.024,	0.022,	0.020,	0.019,	0.019,	0.017,	0.016,	0.016,	0.017,	0.021,	0.038,	0.07	],
"Warenkorb":[	0.437,	0.500,	0.442,	0.244,	0.149,	0.127,	0.144,	0.124,	0.102,	0.086,	0.070,	0.064,	0.072,	0.068,	0.062,	0.060,	0.059,	0.055,	0.053,	0.053,	0.057,	0.070,	0.132,	0.259	],
"Wishlist":[	0.710,	0.953,	0.783,	0.391,	0.242,	0.204,	0.245,	0.218,	0.183,	0.156,	0.126,	0.113,	0.127,	0.120,	0.110,	0.105,	0.098,	0.097,	0.098,	0.098,	0.108,	0.133,	0.233,	0.473	],
"test":[	1.000,	1.000,	1.000,	1.000,	0.936,	0.790,	0.935,	0.827,	0.697,	0.565,	0.435,	0.405,	0.450,	0.421,	0.381,	0.358,	0.344,	0.313,	0.307,	0.292,	0.317,	0.373,	0.660,	1	],
};
/*                                 */

/**
 *
 *
 *
 */
const liveHttpRequest = {
  Artikeldetailseite: 0.15,
  Einstiegsseite: 0.3,
  Errorseite404: 0.5,
  Login: 0.7, /*  */
  Registration: 0.15,
  Produktliste: 0.09,
  Storefront: 0.25,
  Suchergebnisseite: 0.07,
  VirtualAgentAftersales: 0.13,
  Warenkorb: 0.5,
};

/**
 *
 *
 */
export const sampligRates: Record<"live" | "develop", SamplingEnvConfig> = {
  live: {
    [transactionTypes[0]]: pageLoadLive,
    [transactionTypes[1]]: liveHttpRequest,
  },
  develop: { [transactionTypes[0]]: {}, [transactionTypes[1]]: {} },
};

export const getSamplingRate = (
  type: TransactionType,
  pagecluster: string,
  now = new Date(),
  env = import.meta.env.VITE_OTTO_INSTALLATION_ENV,
): number => {
  const current = now.getUTCHours(); /*          */
  const rates = sampligRates[env];

  if (type === "page-load") {
    const { [pagecluster]: pcRates = [] } = rates[type];
    return pcRates[current] ?? 1;
  }

  return rates[type][pagecluster] ?? 1;
};
